module.exports = __webpack_public_path__ + "img/znh.ce31d245.png";